import {
	DataFileTct,
	DocumentSignatureType,
	DocumentTemplateType,
	PendingSignaturePlacementDto,
} from '@dealstack/shared/lib/generated';
import { PredefinedIcons } from '@dealstack/frontend/shared/components/fundament/Icon/Icon.types';

export type TemplateTypesOptions = {
	name: string;
	icon: PredefinedIcons;
};

export enum DOCUMENT_SETTINGS_MODAL_FIELDS {
	WITNESSING_REQUIRED = 'witnessesRequired',
	SIGNATURE_TYPE = 'signatureType',
	IS_SIGNATURE_ADVANCED = 'isSignatureAdvanced',
	INDIVIDUAL_SCHEDULE_REQUIRED = 'individualScheduleRequired',
	COUNTERPARTIES_INCLUDED = 'counterpartiesIncluded',
	GUIDANCE_NOTE = 'guidanceNote',
	IS_TO_BE_SUBMITTED = 'isToBeSubmitted',
	USE_MANUAL_SIGNATURE_PLACEMENT = 'useManualSignaturePlacement',
}

export type DocumentSettings = {
	documentWorkflowFileId: string;
	templateType: DocumentTemplateType;
	witnessesRequired: boolean;
	signatureType: DocumentSignatureType;
	isSignatureAdvanced: boolean;
	isToBeSubmitted: boolean;
	individualScheduleRequired: boolean;
	emailText?: string;
	counterparties: Counterparty[];
	counterpartiesIncluded: boolean;
	guidanceNote?: DataFileTct;
	useManualSignaturePlacement?: boolean;
	showStampMetadata?: boolean;
	signaturePlacements?: PendingSignaturePlacementDto[];
};

export type DocumentSettingsFieldNames = keyof DocumentSettings;

export type Counterparty = {
	chipId: string;
	name: string;
	amount: number;
};
